import React from "react";
import i18n from "../../../i18n/config";

const PINCheckHeader = () => {
  return (
    <h4 className="modal-title text-center">{i18n.t("PAGES.MY_CARD.INDEX.PIN_CHECK_MODAL.TITLE")}</h4>
  );
}

export default PINCheckHeader;